import { Link } from "react-router-dom";
import { useStore } from "@/context/StoreContext";
import { money, subPrice, subPct, memberPrice } from "@/lib/api";
import { bundleSavePct, SERVING } from "@/data/parts";
import { SPOONFUL, PACK_VALUE } from "@/data/content";

export const Spoonful = ({ id }) => (SPOONFUL[id] ? (
  <section data-testid={`spoonful-${id}`} className="mt-8 sticker-sm bg-foam/60 p-5">
    <h3 className="font-display text-2xl">A spoonful with Grandpa</h3>
    <p data-testid={`spoonful-text-${id}`} className="mt-2 text-sm leading-relaxed text-slate-700">{SPOONFUL[id]}</p>
  </section>
) : null);

export const PackValue = ({ id }) => (
  <span data-testid={`pack-value-${id}`} className="mt-2 block rounded-2xl border-2 border-navy bg-white p-3 text-sm">
    <span data-testid={`pack-value-per-${id}`} className="block font-bold">{PACK_VALUE[id][0]}</span>
    <span data-testid={`pack-value-save-${id}`} className="mt-1 block font-normal text-slate-700">{PACK_VALUE[id][1]}</span>
  </span>
);

export const BundleSave = ({ p, className = "" }) => {
  const { byId } = useStore();
  const pct = bundleSavePct(p, byId);
  return pct ? <p data-testid={`bundle-save-${p.id}`} className={`text-sm font-bold text-navy ${className}`}>Save {pct}% vs buying separately</p> : null;
};

export const MemberLine = ({ p, className = "" }) => (p.member_discount === false
  ? <p data-testid={`member-na-${p.id}`} className={`text-xs text-slate-600 ${className}`}>Member discount n/a</p>
  : <p data-testid={`member-price-${p.id}`} className={`text-xs text-slate-600 ${className}`}>Members {money(memberPrice(p))}</p>);

export const hasSub = (p) => !p.coming_soon && subPrice(p) < Number(p.price_usd);

export const ModeToggle = ({ p, mode, setMode, price = money }) => (
  <div role="radiogroup" aria-label="Purchase option" data-testid={`mode-toggle-${p.id}`} className="mt-3 grid grid-cols-2 gap-2 rounded-full border-2 border-navy p-1 text-xs font-bold">
    {[["sub", `Subscribe & save ${subPct(p)}%`], ["once", "One-time"]].map(([k, label]) => (
      <button key={k} type="button" role="radio" aria-checked={mode === k} data-testid={`mode-${k}-${p.id}`} onClick={() => setMode(k)}
        className={`rounded-full px-2 py-1.5 transition-colors ${mode === k ? "bg-navy text-sand" : "text-navy hover:bg-foam"}`}>{label}</button>
    ))}
  </div>
);

export const LOYALTY = "Captain's Club: US$50/year for member prices on most items, renews yearly, cancel anytime online.";

export const LoyaltyLine = ({ testId = "loyalty-line", className = "" }) => (
  <p data-testid={testId} className={`text-sm text-slate-700 ${className}`}>{LOYALTY}{" "}
    <Link to="/captains-club" data-testid={`${testId}-join`} className="font-bold underline decoration-sunny decoration-2 underline-offset-4">Join</Link>
  </p>
);

const COST_TEXT = { "sea-moss": "About US$0.67 a day (US$19.95 / 30 servings = US$0.665)." };

export const ServingInfo = ({ p }) => {
  const s = SERVING[p.id];
  if (!s) return null;
  const [size, per, days] = s;
  return (
    <dl data-testid={`serving-info-${p.id}`} className="mt-5 grid grid-cols-2 sm:grid-cols-4 gap-3 text-sm">
      <div><dt className="text-xs uppercase tracking-widest text-slate-500">Serving size</dt><dd className="font-semibold">{size}</dd></div>
      {per && <div><dt className="text-xs uppercase tracking-widest text-slate-500">Per serving</dt><dd className="font-semibold">{per}</dd></div>}
      {days && <div><dt className="text-xs uppercase tracking-widest text-slate-500">Supply</dt><dd className="font-semibold">{days} days</dd></div>}
      {days && <div><dt className="text-xs uppercase tracking-widest text-slate-500">Cost per day</dt><dd data-testid={`cost-per-day-${p.id}`} className="font-semibold">{COST_TEXT[p.id] || `${money(Number(p.price_usd) / days)}/day`}</dd></div>}
    </dl>
  );
};
